import type { SaveService } from './save';

import { SaveRequest } from './request';
import { MapListingToSavedItem } from './save-listing.map';

export async function SaveListing(this: SaveService, listingId: string): Promise<string> {
  if (!listingId) {
    return '';
  }

  const _listingData = this.listingsService.getListingById(listingId);

  if (!_listingData) {
    return '';
  }

  let timeout;

  if (!this.stateService.userToken()) {
    this.stateService.handleAuthRequest();

    timeout = setTimeout(() => {
      this.stateService.authPromiseRejecter?.();

      return;
    }, 30000);
    // Wait an additional second to ensure the token is set.
    await this.stateService.authPromise();
  }

  if (!this.stateService.userToken()) {
    return '';
  }

  const _savedListing = MapListingToSavedItem(_listingData);

  const _save = await SaveRequest.call(this, _savedListing);

  if (!_save.ok) {
    console.error('Failed to save listing:', await _save.text());
    this.stateService.notifyParentOfStateChange('HF_EVENT:ERROR', {
      code: _save.status,
      message: await _save.text(),
    });

    return '';
  }

  const _saveResult = (await _save.json()) as string[];

  this.filteringService.userSavedListingIds.update((listings) => {
    const _newSavedListing = { id: _saveResult[0], itemId: listingId };
    return [...listings, _newSavedListing];
  });

  clearTimeout(timeout);
  this.stateService.notifyParentOfStateChange('HF_EVENT:HOME_SAVED', { listingId });

  return _saveResult[0];
}
